
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/missinginfo",
      function () {
        return require("private-next-pages/missinginfo/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/missinginfo"])
      });
    }
  